module.exports = __webpack_public_path__ + "static/img/success-yc.c01521f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/success-yc.png
// module id = I7GK
// module chunks = 0